export const BRAND = {
  name: "Sunrise Mart",
  tagline: "Local to Global",
  whatsapp: "+91 9845098207",
  whatsappRaw: "919845098207",
  email: "info@sunrise-mart.com",
  phone: "+91 9845098207",
  blurb:
    "A trusted Indian export house delivering farm-fresh spices, rice, oils and textiles to buyers across the globe — with genuine quality, honest grading and reliable shipping.",
  address: [
    "Sunrise Mart",
    "# 42, MSME, Industrial Estate",
    "Palamaner - 517408",
    "Chittoor Dist., Andhra Pradesh",
    "India",
  ],
  mapUrl: "https://www.google.com/maps?q=13.2055278,78.7343611",
};

export const CERTIFICATIONS = [
  {
    name: "IEC",
    full: "Import Export Code — DGFT, Ministry of Commerce",
    number: "ACGPT9244D",
    validity: "Issued 18 Apr 2025",
    file: "https://customer-assets-m6fa6gv7.emergentagent.net/job_spice-rice-textiles/artifacts/s5g7yo6y_IEC%20Sunrise%20Mart.pdf",
  },
  {
    name: "APEDA",
    full: "Agricultural & Processed Food Products Export Development Authority",
    number: "RCMC/APEDA/17327/2025-2026",
    validity: "Valid till 13 May 2030",
    file: "https://customer-assets-m6fa6gv7.emergentagent.net/job_spice-rice-textiles/artifacts/o9ycab1i_APEDA%20Sunrise%20Mart.pdf",
  },
  {
    name: "Spice Board of India",
    full: "Registration-cum-Membership Certificate (Exporter)",
    number: "CRES/SBCB/25890/2025-2026",
    validity: "Valid till 30 Jul 2028",
    file: "https://customer-assets-m6fa6gv7.emergentagent.net/job_spice-rice-textiles/artifacts/errs6h42_SPICE%20BOARD%20Sunrise%20Mart.PDF",
  },
  {
    name: "Coconut Development Board",
    full: "RCMC — Coconut Development Board, Govt. of India",
    number: "RCMC/CDB/02262/2025-2026",
    validity: "Valid till 31 Mar 2030",
    file: "https://customer-assets-m6fa6gv7.emergentagent.net/job_spice-rice-textiles/artifacts/cvk0c4ke_COCONUT%20BOARD.PDF",
  },
  {
    name: "FSSAI",
    full: "Food Safety & Standards Authority of India License",
    number: "10125999000285",
    validity: "Valid till 01 Jun 2027",
    file: "https://customer-assets-m6fa6gv7.emergentagent.net/job_spice-rice-textiles/artifacts/koz2aj12_FASSAI%202023-2027.pdf",
  },
  {
    name: "UDYAM (MSME)",
    full: "Ministry of MSME — Registered Manufacturing Enterprise",
    number: "UDYAM-AP-02-0004942",
    validity: "Government of India",
    file: "https://customer-assets-m6fa6gv7.emergentagent.net/job_spice-rice-textiles/artifacts/6h573ns6_UDYAM%20-%20SUNRISE%20MART.pdf",
  },
];

export const MARKETS = ["Yemen", "Dubai (UAE)", "Oman"];

export const NOW_EXPORTING = ["Green Cardamom", "Turmeric Finger", "Rice"];

export const IMAGES = {
  hero: "https://static.prod-images.emergentagent.com/jobs/a7a1a365-f8d3-4ae6-9117-8b56172c9e3a/images/c29260d4662d4e03550790b124ac809d406168c75da5b27e985411e9317141bb.jpeg",
  ship: "https://images.unsplash.com/photo-1763887487174-ecf784a25120?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwzfHxnbG9iYWwlMjBjYXJnbyUyMHNoaXAlMjBwb3J0JTIwc3VucmlzZXxlbnwwfHx8fDE3ODY1MTE3MDF8MA&ixlib=rb-4.1.0&q=85",
  cardamom: "https://static.prod-images.emergentagent.com/jobs/a7a1a365-f8d3-4ae6-9117-8b56172c9e3a/images/fabfdf4399ccc965739100bf8268560d01a69efb2f30986dd193a420ed759958.jpeg",
  turmeric: "https://static.prod-images.emergentagent.com/jobs/a7a1a365-f8d3-4ae6-9117-8b56172c9e3a/images/e3992e2f1984f2b45f2834845bf9921c6a4ea5aa4898d7002d309bf134a4bbf0.jpeg",
  spices: "https://static.prod-images.emergentagent.com/jobs/a7a1a365-f8d3-4ae6-9117-8b56172c9e3a/images/af14afa9f802fd483b2a97158839c29aacd9b84bec4852f412690502d5a138cb.jpeg",
  rice: "https://static.prod-images.emergentagent.com/jobs/a7a1a365-f8d3-4ae6-9117-8b56172c9e3a/images/8f8055034ede6d0644d40ce48544110a2a7f42864b8b6f467e64c7807addcb9a.jpeg",
  ricefield: "https://static.prod-images.emergentagent.com/jobs/a7a1a365-f8d3-4ae6-9117-8b56172c9e3a/images/158e737e1e29a0d06f00fde849bc92c8c5ef1f15c632af4ff13ef4f0e25143e3.jpeg",
  oil: "https://static.prod-images.emergentagent.com/jobs/a7a1a365-f8d3-4ae6-9117-8b56172c9e3a/images/5b782b5e423aa74ee3a7c778650098c84cb9bfd496dcfdf40f7b2017043a1ef8.jpeg",
  snacks: "https://static.prod-images.emergentagent.com/jobs/a7a1a365-f8d3-4ae6-9117-8b56172c9e3a/images/ad5e1842fa9bf440ed05fe3303989bdaa4bea2881051b9966e2a2adc33577700.jpeg",
  sweeteners: "https://static.prod-images.emergentagent.com/jobs/a7a1a365-f8d3-4ae6-9117-8b56172c9e3a/images/b61bf03e9a72f227c38e1e19b480df6cdfcd4a4ca8b98a2c261411e9daf28bd9.jpeg",
  honey: "https://static.prod-images.emergentagent.com/jobs/a7a1a365-f8d3-4ae6-9117-8b56172c9e3a/images/dda8e74732fd1217011fceea5f6bf88d7e48f7629d7cfd8df20f401f487f39c2.jpeg",
  ghee: "https://static.prod-images.emergentagent.com/jobs/a7a1a365-f8d3-4ae6-9117-8b56172c9e3a/images/5872e09ac8f8def1b2b29491d90644dcd9f6e84f3dc636848169a0e8c838c440.jpeg",
  textile: "https://static.prod-images.emergentagent.com/jobs/a7a1a365-f8d3-4ae6-9117-8b56172c9e3a/images/ec02edbd8abd6c5604f814324c9eb066844495d5a683267862b89595935f27c7.jpeg",
  weave: "https://static.prod-images.emergentagent.com/jobs/a7a1a365-f8d3-4ae6-9117-8b56172c9e3a/images/ec02edbd8abd6c5604f814324c9eb066844495d5a683267862b89595935f27c7.jpeg",
};

export const CATEGORIES = [
  {
    id: "spices",
    name: "Whole Spices",
    caption: "01",
    image: IMAGES.spices,
    desc: "Hand-graded whole spices from India's finest growing regions.",
    items: [
      "Indian Green Cardamom",
      "Malabar / Tellicherry Black Pepper",
      "Cumin Seeds",
      "Coriander Seeds",
      "Red Chilli",
      "Yellow Turmeric Finger",
      "Nutmeg",
      "Mace",
      "Cloves",
      "Tamarind",
      "Star Anise",
    ],
  },
  {
    id: "powders",
    name: "Ground Powders",
    caption: "02",
    image: IMAGES.turmeric,
    desc: "Freshly milled powders with true colour, aroma and potency.",
    items: [
      "Red Chilli Powder",
      "Yellow Turmeric Powder",
      "Black Pepper Powder",
      "Coriander Powder",
      "Garam Masala Powder",
      "Ginger Powder",
      "Onion Powder",
    ],
  },
  {
    id: "rice",
    name: "Rice",
    caption: "03",
    image: IMAGES.rice,
    desc: "Long-grain aromatic and everyday rice, sortex-clean and export packed.",
    items: [
      "Sona Masuri (Raw & Steam)",
      "1121 Basmati Rice",
      "1509 Basmati Rice",
      "Bashkathi SBA Special (Bengal)",
      "IR64 Rice",
      "Matta Rice",
    ],
  },
  {
    id: "oils",
    name: "Cold-Pressed Oils",
    caption: "04",
    image: IMAGES.oil,
    desc: "Cold-pressed and double-filtered edible oils, pure and unadulterated.",
    items: [
      "Groundnut / Peanut Oil (cold pressed)",
      "Double Filtered Coconut Oil (cold pressed)",
      "Sunflower Oil",
    ],
  },
  {
    id: "seeds",
    name: "Seeds & Superfoods",
    caption: "05",
    image: IMAGES.cardamom,
    desc: "Clean, sortex-graded seeds and superfoods for global food brands.",
    items: [
      "Makhana (Fox Nut)",
      "Peanuts (40/50, 50/60, 60/70)",
      "Mustard (all varieties)",
      "Fenugreek",
      "Fennel",
      "Green Cardamom Seeds",
      "Nigella (Black Kalonji)",
      "Sesame Seeds",
    ],
  },
  {
    id: "millets",
    name: "Millets & Grains",
    caption: "06",
    image: IMAGES.ricefield,
    desc: "Ancient, gluten-free millets riding the global whole-grain wave.",
    items: [
      "Pearl Millet (Bajra)",
      "Finger Millet (Ragi)",
      "Sorghum (Jowar)",
      "Foxtail Millet (Kangni)",
      "Kodo Millet (Varagu)",
      "Barnyard Millet (Sanwa)",
      "Proso Millet (Chena)",
      "Little Millet (Kutki)",
    ],
  },
  {
    id: "snacks",
    name: "Healthy Snacks",
    caption: "07",
    image: IMAGES.snacks,
    desc: "Clean-label snacks built for modern health-first retail shelves.",
    items: [
      "Roasted & Flavoured Makhana",
      "Millet & Ancient-Grain Crisps",
      "Roasted Chana & Lentil Mixes",
      "Baked Khakhra & Wheat Crisps",
      "Beetroot, Banana & Quinoa Chips",
    ],
  },
  {
    id: "sweeteners",
    name: "Jaggery & Sugar",
    caption: "08",
    image: IMAGES.sweeteners,
    desc: "Natural sweeteners — whole & crushed jaggery and refined sugar.",
    items: ["Jaggery — Whole", "Jaggery — Crushed", "Refined Sugar"],
  },
  {
    id: "honey-ghee",
    name: "Honey & Ghee",
    caption: "09",
    image: IMAGES.honey,
    image2: IMAGES.ghee,
    desc: "Pure natural honey and traditional desi cow ghee, sealed for export.",
    items: [
      "Regular Raw Honey",
      "Flavoured Honey",
      "Pure Desi Cow Ghee",
    ],
  },
  {
    id: "textiles",
    name: "Textiles",
    caption: "10",
    image: IMAGES.textile,
    desc: "Woven apparel, uniforms and home linen crafted to buyer specs.",
    items: [
      "Men / Women / Kids Woven Tops & Bottoms",
      "Shirts & Trousers",
      "T-Shirts & Track Pants",
      "Hospital Uniforms",
      "Bedsheets & Pillow Covers",
      "Towels & Home Décor",
    ],
  },
];

export const STRENGTHS = [
  {
    n: "01",
    title: "Direct from the source",
    body: "We buy straight from farms and mandis across India — no middlemen, so you get honest grades at honest prices.",
  },
  {
    n: "02",
    title: "Rigorous quality control",
    body: "Every consignment is sortex-cleaned, moisture-checked and lab-verified before it leaves our facility.",
  },
  {
    n: "03",
    title: "Export-ready compliance",
    body: "Phytosanitary certificates, custom labelling and complete export documentation handled end to end.",
  },
  {
    n: "04",
    title: "Reliable global logistics",
    body: "Trusted freight partners and live shipment tracking — already serving Yemen, Dubai and Oman.",
  },
  {
    n: "05",
    title: "Flexible order volumes",
    body: "From a trial container to bulk repeat orders, we scale with your business and keep quality constant.",
  },
];


export const PROCESS = [
  {
    n: "01",
    key: "sprout",
    title: "Sourced direct from farmers",
    body: "We buy straight from the farmers who grow it — building long-term relationships that guarantee freshness, traceability and fair, transparent pricing with no middlemen.",
  },
  {
    n: "02",
    key: "sort",
    title: "Sorted & graded in-house",
    body: "Every lot moves to our own dedicated sorting unit, where it is cleaned, sortex-graded and quality-checked so only the grade you ordered makes it through.",
  },
  {
    n: "03",
    key: "pack",
    title: "Packed to your specification",
    body: "Our in-house packing unit packs to your exact requirement — bag size, private labelling, cartons or bulk — ready for retail shelves or wholesale distribution.",
  },
  {
    n: "04",
    key: "ship",
    title: "Shipped to your port",
    body: "Complete export documentation, container loading and trusted freight partners get your order moving on time — already serving Yemen, Dubai and Oman.",
  },
];

export const TEXTILE_FACILITY = {
  location: "Palamaner",
  locationNote: "Midway on the Bangalore–Chennai highway",
  heading: "Our own textile house.",
  body:
    "Beyond agri-commodities, we run a full cut-to-pack apparel facility at Palamaner — strategically located midway on the Bangalore–Chennai highway. We manufacture both wovens and knits end to end, so your garments are made, finished and packed under one roof to your exact specification.",
  capabilities: [
    { title: "Cut-to-Pack", body: "Complete in-house line from fabric cutting to final packed cartons." },
    { title: "Woven Manufacturing", body: "Shirts, trousers, uniforms, bedsheets and home linen." },
    { title: "Knit Manufacturing", body: "T-shirts, track pants and everyday knitwear at volume." },
    { title: "Buyer Spec Ready", body: "Private labelling, size sets and export-grade finishing." },
  ],
};

